
import {
  convertDecimal,
  storeDatatoSessionStorage,
  formatByCountry,
  parseByCountry,
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import { BagOrSttReadyToCargo } from "@/domain/entities/ReadyToCargo";
import { Vue } from "vue-class-component";
import { CalculateVolumeApiRequest, CalculateVolumeRequest } from '@/data/payload/api/CargoApiRequest';
import { CALCULATE_TYPE, getConfigDimensionDivider, getConfigIsminimumVolumePerPiece, getConfigMinimumVolumePerPiece } from '../../modules/cargo-module';
import { FlagsPermissionCargo } from '@/feature-flags/flags-permission-cargo';

export default class TableSttSection extends Vue {
  pagination = {
    page: 1,
    limit: 20,
  };

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  // state to delete stt/bag
  wordingDelete = "";
  itemToDelete = {} as BagOrSttReadyToCargo;
  isShowModalDeleteConfirmation = false;
  successModalDelete = false;

  customButton = {
    outline: true,
    iconLeft: "trash-red",
    title: "Hapus",
    textColor: "red-lp-100",
    color: "red-lp-100",
    small: false,
    customClass: "whitespace-no-wrap",
    disabled: false,
    clickFunction: (item: BagOrSttReadyToCargo) => {
      if (!item.bagNo) {
        this.wordingDelete =
          "STT yang Anda hapus akan hilang dari daftar pengiriman";
      } else {
        this.wordingDelete =
          "Semua STT dari No. Bag yang sama akan terhapus dari daftar pengiriman";
      }
      this.itemToDelete = item;
      this.actionModalDelete(true);
    },
  };

  get sttResultFinal() {
    return ReadyToCargoController.sttResultFinal;
  }

  get totalStt() {
    return ReadyToCargoController.sourceSttFromLocalStorage.length;
  }

  get totalSttPieces() {
    return ReadyToCargoController.totalSttPieces;
  }

  get totalGrossWeights() {
    return ReadyToCargoController.totalGrossWeight;
  }

  get totalVolumeWeights() {
    return ReadyToCargoController.totalVolumeWeight;
  }

  get columns() {
    return [
      {
        name: "No.",
        styleHead: "w-10 text-center whitespace-no-wrap",
        styleCustom: "align-top",
        render: (_: any, index: number) => {
          return `<div class="text-black-lp-300">${index +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</div>`;
        },
      },
      {
        name: "No. Bag",
        styleHead: "w-40 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.bagVendorNo || item.bagNo || "-"}
                </div>`;
        },
      },
      {
        name: "No. STT",
        styleHead: "w-40 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].sttNo}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.sttNo}
                </div>`;
        },
      },
      {
        name: "No. Referensi",
        styleHead: "w-40 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].sttNoRefExternal || "-"}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.sttNoRefExternal || "-"}
                </div>`;
        },
      },
      {
        name: "Total Koli",
        styleHead: "w-24 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) =>{
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].sttTotalPiece}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.sttTotalPiece}
                </div>`;
        }
      },
      {
        name: "Berat Kotor",
        styleHead: "w-32 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${formatByCountry(item.sttDetails[x].grossWeight, { type: "weight", country: this.countryCode })} Kg</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${formatByCountry(item.grossWeight, { type: "weight", country: this.countryCode })} Kg
                </div>`;
        },
      },
      {
        name: "Berat Dimensi",
        styleHead: "w-32 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${formatByCountry(item.sttDetails[x].volumeWeight, { type: "weight", country: this.countryCode })} Kg</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${formatByCountry(item.volumeWeight, { type: "weight", country: this.countryCode })} Kg
                </div>`;
        },
      },
      {
        name: "Produk",
        styleHead: "w-32 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].productType}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.productType}
                </div>`;
        },
      },
      {
        name: "Komoditas",
        styleHead: "w-32 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: BagOrSttReadyToCargo) => {
          let html = `<div class="space-y-3">`;
          if (item.sttDetails.length) {
            for (const x in item.sttDetails) {
              html += `<div class="text-black-lp-300">${item.sttDetails[x].commodityName}</div>`;
            }
            html += `</div>`;
            return html;
          }
          return `<div class="text-black-lp-300 whitespace-no-wrap">
                  ${item.commodityName}
                </div>`;
        },
      },
      {
        name: "Action",
        key: "actionable_column",
        styleHead: "w-36 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        showButton: () => {
          return true;
        },
      },
    ];
  }

  // popup delete
  get isShowPopupDelete(): boolean {
    return this.successModalDelete || this.isShowModalDeleteConfirmation;
  }

  get sttResult(): BagOrSttReadyToCargo[] {
    storeDatatoSessionStorage(
      "stt-data",
      ReadyToCargoController.sourceSttFromLocalStorage
    );
    return ReadyToCargoController.sourceSttFromLocalStorage;
  }

  set sttResult(newSttResult: BagOrSttReadyToCargo[]) {
    storeDatatoSessionStorage("stt-data", newSttResult);
    ReadyToCargoController.setSourceFromLocalStorage(newSttResult);
  }

  get bagResult(): {
    bagNo: string;
    stt: BagOrSttReadyToCargo[];
  }[] {
    storeDatatoSessionStorage("bag-data", ReadyToCargoController.bagResult);
    return ReadyToCargoController.bagResult;
  }

  set bagResult(
    newBagResult: {
      bagNo: string;
      stt: BagOrSttReadyToCargo[];
    }[]
  ) {
    storeDatatoSessionStorage("bag-data", newBagResult);
    ReadyToCargoController.setBagResult(newBagResult);
  }

  convertDecimal(value: any) {
    return formatByCountry(Number(value), { type: "weight", country: this.countryCode });
  }

  setSuccessModalDelete(bool: boolean) {
    this.successModalDelete = bool;
  }

  actionModalDelete(bool: boolean) {
    this.isShowModalDeleteConfirmation = bool;
  }

  isDeleteCargoItem() {
    if (this.itemToDelete.sttDetails.length) {
      this.deleteSttResultByBagNumber(
        this.itemToDelete.bagNo || this.itemToDelete.bagVendorNo
      );
    } else {
      this.deleteSttResultBySttNumber(this.itemToDelete.sttNo);
    }
    this.actionModalDelete(false);
    this.setSuccessModalDelete(true);
  }

  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  async deleteSttResultByBagNumber(bagNo: string) {
    const newSttResult = this.sttResult.filter((item: BagOrSttReadyToCargo) => {
      return item.bagNo !== bagNo;
    });
    const newBagResult = this.bagResult.filter(
      (item: { bagNo: string; stt: BagOrSttReadyToCargo[] }) => {
        return item.bagNo !== bagNo;
      }
    );
    this.sttResult = newSttResult;
    this.bagResult = newBagResult;
    await this.$nextTick();
    this.calculateVolume(CALCULATE_TYPE.INIT);
  }

  async deleteSttResultBySttNumber(sttNo: string) {
    const newSttResult = this.sttResult.filter((item: any) => {
      return item.sttNo !== sttNo;
    });
    this.sttResult = newSttResult;
    await this.$nextTick();
    this.calculateVolume(CALCULATE_TYPE.INIT);
  }

  get popupModalData() {
    // if success delete
    if (this.successModalDelete) {
      return {
        success: {
          action: () => {
            this.setSuccessModalDelete(false);
          },
          text: "OK",
        },
        title: "STT Berhasil Dihapus",
        message: `Anda dapat menambahkan STT baru ke daftar pengiriman`,
        image: "image-modal-success",
      };
    }
    // show popup delete
    return {
      success: {
        action: () => this.isDeleteCargoItem(),
        text: "Hapus",
      },
      cancel: {
        action: () => this.actionModalDelete(false),
        text: "Batalkan",
      },
      title: "Hapus STT",
      message: `${this.wordingDelete}`,
      image: "badge-confirmation-general",
    };
  }

  get formBooking() {
    return CargoController.form;
  }

  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }

  get chargeableWeight() {
    return Math.max(
      1,
      this.parseNumber(String(this.totalNewCalculationGrossWeights)),
      this.parseNumber(String(this.totalNewCalculationVolumeWeights))
    );
  }

  async calculateVolume(calculateType = ""){
    await this.$nextTick();
    CargoController.calculateVolume(new CalculateVolumeApiRequest({
      calculateType,
      calculateRequest: new CalculateVolumeRequest({
        cargoType: this.formBooking.cargoType,
        chargeableWeightReweigh: this.chargeableWeight,
        currentGrossWeight: this.parseNumber(this.formBooking.actualTotalCargoGrossWeight),
        height: this.formBooking.actualDimension.height,
        length: calculateType === "INIT" ? 90 : this.formBooking.actualDimension.length,
        width: calculateType === "INIT" ? 60 : this.formBooking.actualDimension.width,
        totalPieces: this.formBooking.actualTotalSTTPieces,
        volumeWeightReweigh: this.parseNumber(this.totalNewCalculationVolumeWeights as any),
        divider: getConfigDimensionDivider(this.formBooking.cargoType),
        isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus),
        minVolumePerPiece: getConfigMinimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus)
      })
    }))
  }
}
